/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Camera_ErrorInputs */



/**
* | output |
* | --- |
* | "Camera access failed" |
*
* @param {Checkin_Qr_Camera_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_camera_error = /** @type {((inputs?: Checkin_Qr_Camera_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Camera_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'accéder à la caméra")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al acceder a la cámara")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro ao acessar a câmera")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile accedere alla fotocamera")
	return /** @type {LocalizedString} */ ("Camera access failed")
});